import React from 'react';

import { useCampaignCardContext } from '../../../campaign-card-context';

import { Column } from '@prisjakt/ui/list/variants';
import { IconQuestionOutlined } from '@prisjakt/ui/icon/question-outlined';
import { DesktopOnly, MediumDown } from 'src/ui/block';
import { Currency } from 'src/components/currency';
import { PriceText } from 'src/components/offer/price/price-text';
import {
  FontColor,
  FontEmphasis,
  FontScale,
  FontWeight,
} from '@prisjakt/ui/text/variants';

import {
  StyledIconTooltip,
  StyledPrice,
  StyledSecondaryPrice,
  StyledSecondaryPriceWrapper,
} from './styles';

export const Prices = () => {
  const { diffPercentage, offerPrice, price } = useCampaignCardContext();

  if (!price) return null;

  return (
    <Column gap={0}>
      <StyledPrice>
        <PriceText color={diffPercentage ? FontColor.NEGATIVE : FontColor.DARK}>
          <Currency price={offerPrice?.memberPrice ?? price.price} />
        </PriceText>

        <StyledSecondaryPriceWrapper>
          {offerPrice?.originalPrice || price.previousPrice ? (
            <StyledSecondaryPrice
              emphasis={FontEmphasis.MEDIUM}
              scale={FontScale.S}
              weight={FontWeight.NORMAL}
            >
              {offerPrice?.originalPrice ? (
                <Currency price={offerPrice?.originalPrice} />
              ) : (
                <span>{price.previousPrice}</span>
              )}
            </StyledSecondaryPrice>
          ) : null}

          {price.previousPriceText && (
            <>
              <DesktopOnly>
                <StyledIconTooltip title={price.previousPriceText}>
                  <IconQuestionOutlined size={14} />
                </StyledIconTooltip>
              </DesktopOnly>

              <MediumDown>
                <div>*</div>
              </MediumDown>
            </>
          )}
        </StyledSecondaryPriceWrapper>
      </StyledPrice>
    </Column>
  );
};
